<div id="manageWebHookDetails" class="pt-5 mt-5" #manageWebHookDetails>
    <app-header title="Web hook details"></app-header>
    <app-webhook-details-list [id]="id"></app-webhook-details-list>
</div>